import { render, staticRenderFns } from "./scene21.vue?vue&type=template&id=685774a9&scoped=true&"
import script from "./scene21.vue?vue&type=script&lang=ts&"
export * from "./scene21.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685774a9",
  null
  
)

export default component.exports